var map = {
	"./i18n/i18n.properties": 229,
	"./i18n/i18n_de.properties": 231,
	"./i18n/i18n_en.properties": 230,
	"./sap/m/messagebundle.properties": 194,
	"./sap/m/messagebundle_de.properties": 196,
	"./sap/m/messagebundle_en.properties": 195,
	"./sap/ui/core/messagebundle.properties": 181,
	"./sap/ui/core/messagebundle_de.properties": 183,
	"./sap/ui/core/messagebundle_en.properties": 182,
	"./view/App.view.xml": 199,
	"sap/ui/core/cldr/de.json": 374,
	"sap/ui/core/cldr/en.json": 375
};
function openui5Resource(req, failOnError) {
  var id = openui5ResourceResolve(req, failOnError);
  if (id === null) {
    return null;
  }
  if(!__webpack_require__.m[id])
    throw new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
  return __webpack_require__(id);
};
function openui5ResourceResolve(req, failOnError) {
  var id = map[req];
  if(!(id + 1)) { // check for number or string
    if (failOnError) {
      throw new Error("Cannot find module '" + req + "'.");
    }
    return null;
  }
  return id;
};
openui5Resource.keys = function openui5ResourceKeys() {
  return Object.keys(map);
};
openui5Resource.resolve = openui5ResourceResolve;
openui5Resource.id = 21;
module.exports = openui5Resource;